// Update contents object below

const contents = {
  header: 'Destination Canada',
  logoTooltip: {
    href: 'https://us-keepexploring.canada.travel/',
    copy: 'https://us-keepexploring.canada.travel/',
    logoPlacement: 'above'
  },
  video:
    'https://player.vimeo.com/video/761671517?h=0a4974deab&color=b89544&title=0&byline=0&portrait=0',
  videoTitle: 'Destination Canada - Ep. 1 Nova Scotia',
  videoAutoPlay: true,
  title: 'episode 1: nova scotia',
  copy:
    'This award-winning chef explores the Mi’kmaq and Acadian cuisine of Nova Scotia – and discovers the soul-healing power of Canada’s maritime regions, with their windswept beauty and welcoming people.',
  url: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/',
  button: 'return to hub',
  url2: 'https://sponsorcontent.cnn.com/interactive/destination-canada/this-is-canada/ontario/'
};

export default contents;
